<script lang="ts">
  import { fade, slide } from 'svelte/transition'
  import { clickOutside } from '../../../util'
  import ChevronDown from './ChevronDown.svelte'

 
  export let menuItem
  export let aSubmenuIsOpen
  export let depth = 1
  let expanded = false

  $: childish = menuItem.ChildNodes?.length > 0
  $: collapsed = $aSubmenuIsOpen && !expanded

  const handleClick = (e)=> {
    expanded = !expanded
    if(aSubmenuIsOpen !== undefined) {
      if(expanded) {
        $aSubmenuIsOpen = true
      } else {
        $aSubmenuIsOpen = false
      }
    }
  }

  const handleClickOutside = (e)=> {
    if(expanded && $aSubmenuIsOpen) {
      expanded = false
      if(aSubmenuIsOpen !== undefined) $aSubmenuIsOpen = false
    }
  }
</script>


{#if !collapsed}
  <li class="department-mobile-menu-item department-mobile-menu-depth-{depth}" transition:slide use:clickOutside on:CLICK_OUTSIDE={handleClickOutside}>
    <span class="flex">
      <a href="{menuItem.Url}">{menuItem.Title}</a>
      {#if childish}
        <button on:click={handleClick}>
          <span class="sr-only">Expand submenu</span>
          <ChevronDown />
        </button>
      {/if}
    </span>
    {#if expanded && childish}
      <ul class="submenu department-mobile-menu-depth-{depth}" transition:slide>
        {#each menuItem.ChildNodes as _}
          <svelte:self menuItem={_} depth={depth + 1}></svelte:self>
        {/each}
      </ul>
    {/if}
  </li>
{/if}


<style lang="scss">
  li.department-mobile-menu-item {
    a {
      display: block;
      flex-grow: 1;
      color: var(--ucBlack);
      text-transform: uppercase;
      font-weight: bold;
      background: none;
      padding: 1.25rem 2rem;
      
      &:hover, &:focus {
        background-color: var(--ucBlack);
        color: white;
        text-decoration: none;
      }
    }
    
    button {
      padding: 1.25rem 2rem;
      border: none;
      background: none;
    }
  }
  
  ul {
    background-color: var(--steger-silver);
    list-style: none;
    padding: 0;
  }
</style>

